import { Card, CardContent, CardHeader, CardTitle } from "../../../client/components/ui/card";
import useTranslation from "../../../client/hooks/useTranslation";
import type { ReportMetrics } from "../../metrics/types";
import { formatCurrency, pnlTextClass, withCount } from "./formatValue";

/** Bilan chiffré de la période : PnL net, nombre de trades, et si le snapshot
 *  est en v2, la présence quotidienne (jours tradés + PnL moyen par jour). */
export function SummarySection({ metrics }: { metrics: ReportMetrics }) {
  const t = useTranslation();
  const daily = metrics.dailyActivity;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{t.reports.summaryTitle}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <div className="text-xs text-muted-foreground">{t.reports.summaryNetPnl}</div>
            <div className={`text-xl font-mono font-semibold ${pnlTextClass(metrics.pnlNet)}`}>
              {formatCurrency(metrics.pnlNet, metrics.currency)}
            </div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground">{t.reports.summaryTrades}</div>
            <div className="text-xl font-mono font-semibold text-foreground">
              {metrics.tradesCount}
            </div>
          </div>

          {daily && (
            <>
              <div>
                <div className="text-xs text-muted-foreground">{t.reports.summaryDaysTraded}</div>
                <div className="text-xl font-mono font-semibold text-foreground">
                  {daily.daysTraded}
                </div>
                <div className="text-xs text-muted-foreground mt-0.5">
                  {withCount(t.reports.summaryOutOfDays, daily.periodTradingDays)}
                </div>
              </div>

              <div>
                <div className="text-xs text-muted-foreground">
                  {t.reports.summaryAvgPnlPerDay}
                </div>
                <div
                  className={`text-xl font-mono font-semibold ${pnlTextClass(daily.avgPnlPerDay)}`}
                >
                  {formatCurrency(daily.avgPnlPerDay, metrics.currency)}
                </div>
              </div>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
